import servise from '@/router/axios'

export const addAdChannelApp = (data) => {
  return servise({
    url: '/app/channel',
    method: 'post',
    data
  })
}

export const updateAdChannelApp = (data) => {
  return servise({
    url: '/app/channel',
    method: 'put',
    data
  })
}

export const getAdChannelAppDetail = (params) => {
  return servise({
    url: '/app/channel',
    method: 'get',
    params
  })
}

